export enum articlesImageTypes {
  FETCH_ARTICLES_IMAGE_REQUEST = "FETCH_ARTICLES_IMAGE_REQUEST",
  FETCH_ARTICLES_IMAGE_SUCCESS = "FETCH_ARTICLES_IMAGE_SUCCESS",
  FETCH_ARTICLES_IMAGE_FAILURE = "FETCH_ARTICLES_IMAGE_FAILURE",
}